import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function FaqAccordion({ title, answer, expanded, handleChangeAccordion }) {
  return (
    <Accordion
      expanded={expanded === title}
      onChange={handleChangeAccordion(title)}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary
        sx={{
          color: "rgb(2, 44, 88)",
          fontSize: "18px",
          fontWeight: "bold",
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{answer}</AccordionDetails>
    </Accordion>
  );
}

export default FaqAccordion;
